export default __webpack_public_path__ + "static/media/UAE.f4c0db46.jpg";